/* eslint-disable */
import React, { useState, useEffect } from "react";
import Select from "react-select";
import { useParams } from "react-router-dom";

/*------ import url and method ------*/
import * as url from "helper/UrlHelper";
import { getData } from "utils/Gateway";

import { assetImages } from "constants";

const ViewConnectModal = ({ token, personId, setPersonId }) => {
  const [isconnected, setIsconnected] = useState(false);
  const [connectDate, setConnectDate] = useState("");
  const [requestDate, setRequestDate] = useState("");

  //function for send request
  const getConnectDetails = async () => {
    try {
      let requestURL =
        url.API_BASE_URL +
        url.API_GET_CONTACT_DETAILS_BY_USER +
        `?token=${token}&personid=${personId}`;

      // console.log(requestURL);
      const response = await getData(requestURL);

      console.log(response);

      if (response.status) {
        setIsconnected(response.data.isconnected);
        setConnectDate(response.data.connectdate);
        setRequestDate(response.data.requestdate);
      }
    } catch (error) {
      error.message;
    }
  };

  //reset function
  const resetHandler = () => {
    setConnectDate("");
    setRequestDate("");
    setIsconnected(false);
    setPersonId(null);
  };

  useEffect(() => {
    if (personId) {
      getConnectDetails();
    }
  }, [personId]);

  return (
    <div className="conatct_modal success_popup">
      <div
        className="modal fade"
        id="connect_info_modal"
        data-bs-backdrop="static"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h3 className="modal-title">View Details</h3>
              <button
                type="button"
                className="close rounded-circle"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={resetHandler}
              >
                <i className="material-icons-outlined text-black">close</i>
              </button>
            </div>
            <div className="modal-body py-4 px-4">
              <div className="success_graphics text-center mb-3">
                <img
                  src={
                    isconnected ? assetImages.checkTick : assetImages.alertInfo
                  }
                  alt=""
                />
              </div>
              <div className="success_text text-center">
                {/* <h3 className="text-uppercase">
                  Connect
                </h3> */}

                <p className="text-primary mt-4 fs-sm fw-medium text-uppercase d-flex align-items-center justify-content-center gap-2">
                  {/* <i className="material-icons">check_circle</i> */}
                  <span>{`${isconnected ? "Connected" : "Request Send"} on ${
                    connectDate == ""
                      ? requestDate == ""
                        ? ""
                        : requestDate
                      : connectDate
                  }`}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewConnectModal;
